import { render, staticRenderFns } from "./editScriptsEditFolder.vue?vue&type=template&id=6036b218&scoped=true"
import script from "./editScriptsEditFolder.vue?vue&type=script&lang=js"
export * from "./editScriptsEditFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6036b218",
  null
  
)

export default component.exports